import { BlipCommandBaseRequest } from "../../../base/models/BlipCommandBaseRequest";

export class GetResourceRequest extends BlipCommandBaseRequest {
  constructor(resource: string) {
    super("/resources/" + resource, "GET", "MESSAGING");
  }
}
